import Slider, {
  MobileSlider
} from '../../Molecules/Slider';

import CardReview, {
  Props as CardReviewProps
} from '../../Molecules/CardReview';
import './styles.css';

interface Props {
  reviewList: CardReviewProps[];
}
function CardReviewSlider({ reviewList }: Props) {
  return (
    <div className="slider-review-wrap w-full overflow-hidden">
      <div className="mx-auto gap-10 overflow-visible py-7 lg:max-w-4xl">
        <div className="hidden lg:block">
          <Slider
            navigationOutside
            centeredSlides
            slidesPerView="auto"
            slides={reviewList.map((review) => (
              <CardReview
                key={reviewList.indexOf(review)}
                textClassname="line-clamp-6"
                {...review}
              />
            ))}
          />
        </div>
        <div className="lg:hidden">
          <MobileSlider
            slides={reviewList.map((review) => (
              <CardReview
                key={reviewList.indexOf(review)}
                {...review}
              />
            ))}
          />
        </div>
      </div>
    </div>
  );
}

export default CardReviewSlider;
